export const incrementQuestionCounter = (form) => {
  const positionElement = form.querySelector(".quiz-form__question-counter span.number__position");
  positionElement.innerText = (parseInt(positionElement.textContent) + 1).toString();
};
